import { render, staticRenderFns } from "./addMaterialModal.vue?vue&type=template&id=3843104a&scoped=true"
import script from "./addMaterialModal.vue?vue&type=script&lang=js"
export * from "./addMaterialModal.vue?vue&type=script&lang=js"
import style0 from "./addMaterialModal.vue?vue&type=style&index=0&id=3843104a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3843104a",
  null
  
)

export default component.exports